import { AgentService } from "@adfenix/types";
import { useMutation, useQuery } from "@tanstack/react-query";
import { handleError } from "api/helper";
import { AgentServiceApi, MediaServiceApi } from "api/services";

const {
  agent: { authV1AgentDetail: getAgentById, authV1AgentUpdate: updateAgent },
  imageTypeSettings: { authV1ImageTypeSettingsDetail: getImageTypeSettings }
} = AgentServiceApi;

const {
  image: { authV1ImageGetUploadedImageCreate: getUploadedImage }
} = MediaServiceApi;

export const useGetAgentById = (agentId: string | undefined) =>
  useQuery(
    ["getAgentById", agentId],
    async () => {
      const agent = await getAgentById(agentId!);

      if (!agent.image) return agent;

      try {
        const media = await getUploadedImage({
          url: agent.image,
          maintainFileType: false
        });
        return { ...agent, image: media.uploadedUrl };
      } catch (e) {
        return agent;
      }
    },
    {
      enabled: !!agentId
    }
  );

export const imageTypeSettingsCacheKey = "imageTypeSettings";
export const useGetImageTypeSettings = (hqId: string | undefined) =>
  useQuery(
    [imageTypeSettingsCacheKey, hqId],
    () => getImageTypeSettings(hqId!),
    {
      enabled: Boolean(hqId)
    }
  );

export const useUpdateAgentById = () => {
  return useMutation(
    ({
      automaticUpdatesEnabled,
      id,
      image,
      landingPage,
      primaryHqId,
      ...rest
    }: AgentService.AgentModel) => {
      const request: AgentService.UpdateAgentRequest = {
        agentId: id,
        landingPageUrl: landingPage,
        imageUrl: image,
        hqId: primaryHqId,
        ...rest
      };
      if (!request.coordinates?.latitude || !request.coordinates?.longitude) {
        request.coordinates = undefined;
      }
      return updateAgent(request).catch(handleError);
    }
  );
};
